import { OrdersSection } from "src/apps/components/ordersSection/OrdersSection";
import { OrderOtherDocument } from "src/contexts/documentationArea/domain/OrderOtherDocument";
import { OtherDocumentsContent } from "./OtherDocumentsContent";

interface DocumentsProps {
  otherDocuments: OrderOtherDocument[];
}

const ACCORDION_HEADER_OTHER_DOCUMENTS = "documentation_area.other_documents.section_header";
const ACCORDION_HEADER_OTHER_DOCUMENTS_DESCRIPTION =
  "documentation_area.other_documents.section_description";

export const OtherDocuments = ({ otherDocuments }: DocumentsProps) => {
  if (!otherDocuments.length) return null;

  return (
    <OrdersSection
      title={ACCORDION_HEADER_OTHER_DOCUMENTS}
      description={ACCORDION_HEADER_OTHER_DOCUMENTS_DESCRIPTION}
      content={<OtherDocumentsContent otherDocuments={otherDocuments} />}
      isCompleted={false}
    />
  );
};
